import { useEffect, useState } from 'react';
import PaymentDialogComponent from 'src/pages/payment/payment-dialog.component';
import HttpServices from 'src/services/httpService';
import { paymentModuleUrl } from 'src/services/urlService';
import TagManager from 'react-gtm-module';   // or use the helper above

const PlanPaymentComponent = ({ planId, amount, currencySymbol, upgradeItems, handlePaymentDialog,annualValue,planName }) => {

  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    createPaymentLink();
  }, []);
  
  const successCallback = (data, message) => {
    setClientSecret(data.payment_intent);
    const currency = currencySymbol === "₹" ? "INR" : "USD"
    TagManager.dataLayer({
      dataLayer: {
        event: 'payment_initiated',
        plan: planName,
        value: annualValue,
        currency: currency
      }
    });
  }
  const createPaymentLink = () => {
    let paymentForm = {
      new_plan_id: planId,
      add_ons: upgradeItems,
    };
    let postProps = {
      url: paymentModuleUrl.createPayment,
      body: paymentForm,
      successCallback
    }
    HttpServices.Post(postProps);
  };
  return (
    clientSecret && <PaymentDialogComponent clientSecret={clientSecret} amount={amount}planName={planName} currencySymbol={currencySymbol} handleClose={handlePaymentDialog} />
  );
}
export default PlanPaymentComponent;